

import { Route, Routes, Navigate, useLocation} from 'react-router-dom';
import LoginView from './view/LoginView';
import ComponentTestView from './view/ComponentTestView';
import { OverlayManager } from './ui/overlay/Overlay';
import Dashboard from './view/dashboard/Dashboard';
import User from './data/User';
import { PropsWithChildren, useEffect, useState } from 'react';
import { MainView } from './view/dashboard/main/MainView';
import { SettingsView } from './view/dashboard/settings/SettingsView';
import UIMapLoadScript from './ui/map/UIMapLoadScript';
import { MainViewMap } from './view/dashboard/main/MainViewMap';
import { UILoadingBox } from './ui/UILoadingBox';
import Api from './api/Api';
import AppData from './data/AppData';
import FormatUtil from './util/FormatUtil';
import './App.scss';
import { CallHistory } from './view/dashboard/main/CallHistory';

function App() {

    let [appReady, setAppReady] = useState<boolean>(false);

    useEffect(()=>{

        if(User.state.isRestoring){
            Api.access.login(($success,$results)=>{
                if($success){
                    setAppReady(true);
                }else{
                    setAppReady(true);
                }
            });

        }else{
            setAppReady(true);
        }

    },[]);


    return (
        <UIMapLoadScript onLoad={()=>{}} onError={()=>{}}>
            <div className="App">
                {appReady && (  
                    <Routes>      
                        <Route path={Dashboard.PATH} element={<AuthRoute><Dashboard/></AuthRoute>}>
                            <Route path={MainView.PATH} element={<MainView/>}>
                                <Route path={MainViewMap.PATH}/>
                                <Route path={CallHistory.PATH}/>
                            </Route>
                            <Route path={ComponentTestView.PATH} element={<ComponentTestView/>}/>
                            <Route path={SettingsView.PATH} element={<SettingsView/>}/>
                            <Route path="*" element={<div>uhh</div>}/>
                        </Route>
                        <Route path={LoginView.PATH} element={<NotAuthRoute><LoginView/></NotAuthRoute>}/>
                        <Route path="*" element={<Navigate to={Dashboard.PATH}/>}/>
                    </Routes>
                )}
                {!appReady && (
                    <UILoadingBox fullHeight/>
                )}
                <OverlayManager/>      
                <div className="appFooter">
                    <div>
                        {Api.strEnvName}
                    </div>
                    <div>
                        {FormatUtil.dateHMSMDY(AppData.buildDate)}            
                    </div>
                </div>                    
            </div>
        </UIMapLoadScript>
    );
}




export default App;


interface IAuthRouteProps extends PropsWithChildren{
}

export function AuthRoute($props:IAuthRouteProps){

    if(User.storage.getItem("user")){

        let summary = JSON.parse(User.storage.getItem("user")||"").summary;
        
        if(summary && summary.token){

            User.state.isLoggedIn = true;
            User.state.loginEmail = summary.email;
            User.state.loginToken = summary.token;
            User.state.isECRCUser = false;
            
            let rights = summary.user_rights;

            if(rights["PSAP_CLIENT_ID"]){
                User.state.psapClientID = rights["PSAP_CLIENT_ID"];
            }
            if(rights["PSAP_REGION_ID"]){
                User.state.psapRegionID = rights["PSAP_REGION_ID"];   
            }
            if(rights["PSAP_HANDLING_MODE"]){
                User.state.psapHandlingMode = rights["PSAP_HANDLING_MODE"];
            }
            if(rights["UI_SUPPRESS_MAP_UPDATES"]){
                User.state.suppressMapUpdates = true;
            }

            if(rights["IS_ECRC_USER"]){
                User.state.isECRCUser = true;
            }

            if(summary.user_role){
                let role = summary.user_role;

                if(role=="ADMIN"){
                    User.state.isAdminUser = true;
                }
            }

            if(summary.username){
                let name = summary.username;
                User.state.loginUsername = name;
            }

            if(summary.pk){
                let pk = summary.pk;
                User.state.pk = pk;
            }

            if(summary.company_id){
                let companyId = summary.company_id;
                User.state.company_id = companyId;
            }
            if(summary.security_group_id){
                let securityGroupId = summary.security_group_id;
                User.state.security_group_id = securityGroupId;
            }
            if(summary.phone_number){
                let phoneNumber = summary.phone_number;
                User.state.phone_number = phoneNumber;
            }


        }
    }
    let jsx:JSX.Element = <></>;
    //if(User.state.isLoggedIn){
    if(localStorage.getItem("token")){
        jsx = <>{$props.children}</>;
    }else{
        jsx = <Navigate to={LoginView.PATH}/>;
    }
    return jsx;
}

export function NotAuthRoute($props:IAuthRouteProps){

    let jsx:JSX.Element = <></>;
    //if(User.state.isLoggedIn){
    if(localStorage.getItem("token")){
        jsx = <Navigate to={Dashboard.PATH}/>;
    }else{
        jsx = <>{$props.children}</>;
    }
    return jsx;
}

